import React from "react";
import { Group, Progress, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export interface DownloadProgressState {
  loaded: number;
  total?: number;
}

const formatMegabytes = (bytes: number) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const DownloadProgressBar: React.FC<DownloadProgressState> = ({ loaded, total }) => {
  const { t } = useTranslation();

  return (
    <Stack gap={4} data-testid="download-progress">
      <Group justify="space-between" gap="sm">
        <Text size="sm">{t("downloadingToDevice")}</Text>
        <Text size="sm" c="dimmed">
          {formatMegabytes(loaded)}
          {total ? ` / ${formatMegabytes(total)}` : ""}
        </Text>
      </Group>
      {total ? <Progress value={(loaded / total) * 100} animated /> : null}
    </Stack>
  );
};

export default DownloadProgressBar;
